
import "../css/user.css";

import { useGoogleAuth, useFacebookAuth, logUserOut } from "../hooks/useAuth";
import { useOAuth } from "../context/OAuthContext";

import { useUser, useUserUpdate } from "../context/UserContext";


import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { usePlatform } from "../context/PlatformContext";

import { reportInteraction } from "../utilities/server-update-analytics";


export {
  AccountModal
};


/* =========================== Account Modal =========================== */

function AccountModal() {

  const { user } = useUser();

  // Adds Log In Modal Event Handlers
  useEffect( () => {
    addAccountModalEventHandlers();
  }, [user]);

  return (
    <div>
      {
        user == null ?
          <LogInModal />
        :
          <UserModal />
      }
    </div>
  );
}


function LogInModal() { // Not-Already Logged In User

  const { GoogleAuth } = useGoogleAuth();
  const { FacebookAuth } = useFacebookAuth();

  const { platform } = usePlatform();
  if( !platform ) return <></>;

  /*
  const { GoogleLoginButton } = useOAuth();
  if( !GoogleLoginButton ) return <></>;
  */

  return (
    <div id="log-in_modal">
      <div className="log-in_modal_container">
        <header className="log-in_modal_header">
          <h3>Sign in to</h3>
          <h2><strong>{ platform.brand.name }</strong></h2>
        </header>

        <div className="log-in_modal_content">
          <p>Log in to save your progress.</p>
          <p>For the strongest security, we use trusted third-parties to handle account credentials.</p>
          <p>We won't post anything anywhere.</p>
          <div className="log-in_modal_content_buttons">
            <GoogleAuth />
            <FacebookAuth />
            {/*
            <GoogleLoginButton />
            */}
          </div>
        </div>
      </div>
    </div>
  );
}

function UserModal() { // Already Logged In User

  const { user } = useUser();
  if( user == null ) return <></>;


  const userLoginMethod = user.loginMethod ? 
    user.loginMethod.charAt(0).toUpperCase() + user.loginMethod.slice(1)
  :
    undefined;
  
  const userEmail = user.email ? user.email : undefined;

  const welcomeMessageJSX = <p>Welcome, <strong>{user.name}</strong>!</p>;

  let loginInfoMessageJSX: JSX.Element | undefined;

  if( userLoginMethod && userEmail ) {
    loginInfoMessageJSX = (
      <p>
        Logged in with <strong>{userLoginMethod}</strong> as <strong>{userEmail}</strong>
      </p>
    )
  }
  else if( userLoginMethod ) {
    loginInfoMessageJSX = <p>Logged in with <strong>{userLoginMethod}</strong></p>;
  }
  else if( userEmail ) {
    loginInfoMessageJSX = <p>Logged in as <strong>{userEmail}</strong></p>;
  }


  // TODO: Add Delete Account Functionality


  return (
    <div id="log-in_modal">
      <div className="log-in_modal_container">
        <header className="log-in_modal_header">
          <h3><strong>Account Management</strong></h3>
        </header>

        <div className="log-in_modal_content">
          { welcomeMessageJSX }
          { loginInfoMessageJSX }
          <LogOutButton />
        </div>
      </div>
    </div>
  )
}

function LogOutButton() {

  // TODO: Have this Logic in auth.tsx ? But need consider Server doing the Redirect (?) or else need import useNavigate for just this one use...?
  const navigate = useNavigate();

  const { user } = useUser();
  const { removeUser } = useUserUpdate();

  if( user == null ) return <></>;

  const handleLogOut = () => {
    // TODO: Consider if better way to do this. Just hard-navigating to new Page
    // ... Without, it doesn't close Modal (NEED FORCE RERENDER)
    removeUser();
    logUserOut(user);
    //navigate("/product");

    // TODO: Force ReRender...
    hideModal( getAccountModal() );

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: { elementId: "log-out_button" }
    });

    // TODO: HUGE HACK - Cuz can't refetch Feature data once log-in from Program Page via Locked Lesson Login Button -- Never seems trigger useEffect... -- Bashed head against wall for hours -- Going with this for now
    window.location.reload();
  }


  return (
    <>
      <button className="log-out_button" onClick={ () => handleLogOut() }>Log Out</button>
    </>
  );
}




/* =========================== HELPERS =========================== */

function addAccountModalEventHandlers() {
  const modal: HTMLElement | null = getAccountModal();
  if( modal == null ) return; /* TODO: ERROR HANDLE */

  // TODO: NOT THE "React" way of doing things (see "Refs" Lesson in FE Expert)
  // TODO: ERROR HANDLE if no Classes with this name...
  // TODO: Not scalable to having this apply outside "Header"...
  //const logInButton: HTMLElement = document.getElementsByClassName("site-header_log-in")[0] as HTMLElement;
  const logInButtons: HTMLElement[] = Array.from(document.getElementsByClassName("log-in_button")) as HTMLElement[];
  //if( logInButton == null ) return; // TODO: ERROR HANDLE (if User Logged in...?)

  //const closeButton = document.getElementByClassName("");
  logInButtons.forEach( (logInButton: HTMLElement) => {
    logInButton.onclick = () => {
      showModal( modal );

      reportInteraction({
        interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
        interactionDetails: { elementId: "log-in_button" }
      });
    }
  })

  window.onclick = event => {
    if( event.target == modal ) {
      hideModal( modal );
    }
  }
}

function getAccountModal() {
  return document.getElementById("log-in_modal");
}

function showModal( modal: HTMLElement | null ) {
  if( modal == null ) return;

  modal.style.display = "flex";
  document.body.style.overflow = "hidden";
}

function hideModal( modal: HTMLElement | null ) {
  if( modal == null ) return;

  modal.style.display = "none";
  document.body.style.overflow = "auto";
}
